/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  StripePaymentReportsDTO,
  StripePaymentReportsDTOOptional,
  StripePaymentReportsDTOMetaI,
  StripePaymentReportsDTOTrackedI,
} from "./stripe-payment-reports-dto";
import {
  StripePaymentReportsDTOTracked,
  StripePaymentReportsDTOMeta,
} from "./stripe-payment-reports-dto";

/**
 *
 * @export
 * @interface StripePaymentReportsResultDTO
 */
export interface StripePaymentReportsResultDTOOptional {
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportsResultDTO
   */
  queueId?: string;
  /**
   *
   * @type {StripePaymentReportsDTO}
   * @memberof StripePaymentReportsResultDTO
   */
  stripePaymentReports?: StripePaymentReportsDTOOptional;
}

export interface StripePaymentReportsResultDTO extends StripePaymentReportsResultDTOOptional {
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportsResultDTO
   */
  queueId?: string;
  /**
   *
   * @type {StripePaymentReportsDTO}
   * @memberof StripePaymentReportsResultDTO
   */
  stripePaymentReports?: StripePaymentReportsDTO;
}

export interface StripePaymentReportsResultDTOTrackedI {
  /**
   *
   * @type {string}
   * @memberof StripePaymentReportsResultDTO
   */
  queueId?: string;
  queueIdIsSet: boolean;
  /**
   *
   * @type {StripePaymentReportsDTO}
   * @memberof StripePaymentReportsResultDTO
   */
  stripePaymentReports?: StripePaymentReportsDTOTrackedI;
  stripePaymentReportsIsSet: boolean;
}

transformDatesMap.set(
  "StripePaymentReportsResultDTO",
  function (model: StripePaymentReportsResultDTO) {
    const transformDatesstripePaymentReports = transformDatesMap.get(
      "StripePaymentReportsDTO",
    );
    if (transformDatesstripePaymentReports && model.stripePaymentReports) {
      transformDatesstripePaymentReports(model.stripePaymentReports);
    }
  },
);

export type StripePaymentReportsResultDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  queueId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  stripePaymentReports: PropertyMeta<StripePaymentReportsDTOMetaI>;
}>;

export var StripePaymentReportsResultDTOMeta: StripePaymentReportsResultDTOMetaI =
  {} as StripePaymentReportsResultDTOMetaI;
StripePaymentReportsResultDTOMeta = typeMeta("StripePaymentReportsResultDTO", {
  queueId: propertyMeta("queueId", false, false, false, MetaTypesBase.string),
  stripePaymentReports: propertyMeta(
    "stripePaymentReports",
    false,
    false,
    false,
    StripePaymentReportsDTOMeta,
  ),
});

const metaI = StripePaymentReportsResultDTOMeta;

registerMeta(() => {});

export class StripePaymentReportsResultDTOTracked implements StripePaymentReportsResultDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  queueId__I?: string = undefined;
  queueIdIsSet: boolean = false;
  set queueId(v: undefined | string) {
    if (v !== undefined) {
      this.queueId__I = v;
      this.queueIdIsSet = true;
    } else {
      this.queueId__I = v || undefined;
      this.queueIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get queueId() {
    return this.queueId__I;
  }
  stripePaymentReports__I?: StripePaymentReportsDTOTracked = undefined;
  stripePaymentReportsIsSet: boolean = false;
  set stripePaymentReports(v: undefined | StripePaymentReportsDTOTracked) {
    if (v !== undefined) {
      this.stripePaymentReports__I = v;
      this.stripePaymentReportsIsSet = true;
    } else {
      this.stripePaymentReports__I = v || undefined;
      this.stripePaymentReportsIsSet = false;
    }
    this.changeTracker = true;
  }
  get stripePaymentReports() {
    return this.stripePaymentReports__I;
  }
  constructor(
    config?: StripePaymentReportsResultDTOOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.stripePaymentReports?.setIds();
  }
  assignFrom(
    config: StripePaymentReportsResultDTOOptional,
    options?: AssignOptions,
  ): StripePaymentReportsResultDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.queueId && this.queueIdApplyFilter(optionsRequired.filter)) {
      this.queueId = config.queueId;
      if (optionsRequired.unassign) this.queueIdIsSet = false;
      else this.queueIdIsSet = true;
    }
    if (
      config.stripePaymentReports &&
      this.stripePaymentReportsApplyFilter(optionsRequired.filter)
    ) {
      this.stripePaymentReports = new StripePaymentReportsDTOTracked(
        config.stripePaymentReports,
        options,
      );
      if (optionsRequired.unassign) this.stripePaymentReportsIsSet = false;
      else this.stripePaymentReportsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): StripePaymentReportsResultDTOTrackedI {
    const cloned = {} as StripePaymentReportsResultDTOTrackedI;
    if (
      this.queueIdIsSetDeep() &&
      this.queueIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.queueIdIsSet = true;
      cloned.queueId = this.queueId;
    } else {
      //cloned.queueIdIsSet = false
    }
    if (
      this.stripePaymentReportsIsSetDeep() &&
      this.stripePaymentReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.stripePaymentReportsIsSet = true;
      cloned.stripePaymentReports =
        this.stripePaymentReports?.removeUnset(filter);
    } else {
      //cloned.stripePaymentReportsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): StripePaymentReportsResultDTOTrackedI {
    if (!this.queueIdApplyFilter(filter)) this.queueIdIsSet = false;

    if (!this.stripePaymentReportsApplyFilter(filter))
      this.stripePaymentReportsIsSet = false;
    this.stripePaymentReports?.unassignAll(filter);

    return this;
  }
  queueIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportsResultDTOMeta.queueId,
      StripePaymentReportsResultDTOMeta,
      this.queueId,
      this,
    );
  }
  queueIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.queueIdIsSet && this.queueIdApplyFilter(filter)) return true;

    return false;
  }
  stripePaymentReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripePaymentReportsResultDTOMeta.stripePaymentReports,
      StripePaymentReportsResultDTOMeta,
      this.stripePaymentReports,
      this,
    );
  }
  stripePaymentReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.stripePaymentReportsIsSet &&
      this.stripePaymentReportsApplyFilter(filter)
    )
      return true;
    return this.stripePaymentReports?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.queueIdIsSetDeep(filter)) return true;
    if (this.stripePaymentReportsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
